// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../navbar/navbar.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../utils/img/bg-generico.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.welcome {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #e4e6eb;
  height: 100vh;
}

.row-welcome {
  display: flex;
  justify-content: center;
  align-items: center;
}

.img-homepage {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 262px;
  width: 94.8%;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-family: "Lato", sans-serif !important;
  font-size: 40px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  margin: 1rem 2rem 2rem 2rem;
}

.strong-miia {
  padding: 0.5rem;
  font-size: 42px;
}

.main-content .delete-nav-chelms .chelmsford-desktop {
  display: none !important;
}
.main-content .delete-nav-chelms .btn-login {
  display: none !important;
}

@media (max-width: 576px) {
  .quickAcces-container {
    display: none !important;
  }
  .img-homepage {
    width: 90%;
    padding: 0;
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .homePage-content {
    width: 100%;
  }
}
.homePage-img-container {
  display: flex;
  justify-content: center;
}

`, "",{"version":3,"sources":["webpack://./src/sass/layout/welcome/welcome.scss","webpack://./src/sass/layout/welcome/welcome.css","webpack://./src/sass/utilities/_variables.scss"],"names":[],"mappings":"AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;ACFF;;ADIA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ACDF;;ADGA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,mBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CE5BK;EF6BL,eAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,2BAAA;ACDF;;ADGA;EACE,eAAA;EACA,eAAA;ACAF;;ADII;EACE,wBAAA;ACDN;ADGI;EACE,wBAAA;ACDN;;ADMA;EACE;IACE,wBAAA;ECHF;EDKA;IACE,UAAA;IACA,UAAA;IACA,aAAA;IACA,cAAA;IACA,eAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;ECHF;EDKA;IACE,WAAA;ECHF;AACF;ADWA;EACE,aAAA;EACA,uBAAA;ACTF","sourcesContent":["@import \"../../layout/navbar/navbar.css\";\n@import \"../../utilities/mixins\";\n@import \"../../utilities/variables\";\n\n.welcome {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #e4e6eb;\n  height: 100vh;\n}\n.row-welcome {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.img-homepage {\n  background-image: url(\"../../../utils/img/bg-generico.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 262px;\n  width: 94.8%;\n  border-radius: 12px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  font-family: $Font;\n  font-size: 40px;\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n  margin: 1rem 2rem 2rem 2rem;\n}\n.strong-miia {\n  padding: 0.5rem;\n  font-size: 42px;\n}\n.main-content {\n  .delete-nav-chelms {\n    .chelmsford-desktop {\n      display: none !important;\n    }\n    .btn-login {\n      display: none !important;\n    }\n  }\n}\n\n@media (max-width: 576px) {\n  .quickAcces-container {\n    display: none !important;\n  }\n  .img-homepage {\n    width: 90%;\n    padding: 0;\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .homePage-content {\n    width: 100%;\n  }\n}\n// .btn-lenguage {\n//   position: absolute;\n//   right: 2.5rem;\n//   top: 0.5rem;\n// }\n\n.homePage-img-container {\n  display: flex;\n  justify-content: center;\n}","@import \"../../layout/navbar/navbar.css\";\n.welcome {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: #e4e6eb;\n  height: 100vh;\n}\n\n.row-welcome {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.img-homepage {\n  background-image: url(\"../../../utils/img/bg-generico.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position: center;\n  height: 262px;\n  width: 94.8%;\n  border-radius: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n  font-family: \"Lato\", sans-serif !important;\n  font-size: 40px;\n  letter-spacing: 0px;\n  color: #ffffff;\n  opacity: 1;\n  margin: 1rem 2rem 2rem 2rem;\n}\n\n.strong-miia {\n  padding: 0.5rem;\n  font-size: 42px;\n}\n\n.main-content .delete-nav-chelms .chelmsford-desktop {\n  display: none !important;\n}\n.main-content .delete-nav-chelms .btn-login {\n  display: none !important;\n}\n\n@media (max-width: 576px) {\n  .quickAcces-container {\n    display: none !important;\n  }\n  .img-homepage {\n    width: 90%;\n    padding: 0;\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .homePage-content {\n    width: 100%;\n  }\n}\n.homePage-img-container {\n  display: flex;\n  justify-content: center;\n}\n\n","// Utils\n$DecorationNone: none;\n$Font: \"Lato\", sans-serif !important;\n$Font-size-navbar: 12px;\n$LetterSpacing: 0px;\n\n// Colors\n$Transparent: rgba(0, 0, 0, 0);\n$RedColor: rgb(143, 0, 60, 1);\n$White: rgba(255, 255, 255, 1);\n$Black: rgba(26, 25, 25, 1);\n$MainBackgroundColor: rgba(247, 248, 249, 1);\n$SecondaryBackgroundColor: rgba(221, 208, 208, 0.5);\n$GrayColor: rgba(204, 204, 204, 1);\n$LinkColor: rgba(18, 101, 183, 1);\n$LinkSecondColor: rgba(78, 125, 162, 1);\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
